import { ZonesModel } from '@/models/sidebar/info.model';

const colors: ZonesModel = {
  jews: '#296d98',
  jews_puppet: '#3792cb',
  jews_occupied: '#45b6fe',
  uk: '#b30000',
  uk_puppet: 'red',
  uk_occupied: '#ff7f7f',
  arabs: 'green',
  arabs_puppet: '#66a103',
  arabs_occupied: '#97f000',

  // 1956 war allies, ie UK and France
  allies: '#b30000',
  allies_puppet: 'red',
  allies_occupied: '#ff7f7f',

  // Global
  neutral: '#ffad46',
  neutral_zone: 'transparent',
  default: '#ffad46',
};

export default colors;
